import { useConfig, useNetwork } from "wagmi";

/** @deprecated fixme useNetworks returns empty chains array if not connected, if so use chain array from publicClient chains */
export const useChainsIfNotConnected = () => {
  const { chains } = useNetwork();
  const { publicClient } = useConfig();
  return !chains.length ? publicClient.chains : chains;
};
